import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormArrayPipe } from './form-array.pipe';
import { FormControlPipe } from './form-control.pipe';
import { FormGroupPipe } from './form-group.pipe';
import { MeetingTypePipe } from './meeting-type.pipe';
import { AttendeeTypePipe } from './attendee-type.pipe';
import { ShouldShowInstitutionalInvestorTypePipe } from './should-show-institutional-investor-type.pipe';



@NgModule({
  declarations: [
    FormArrayPipe,
    FormControlPipe,
    FormGroupPipe,
    MeetingTypePipe,
    AttendeeTypePipe,
    ShouldShowInstitutionalInvestorTypePipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    FormArrayPipe,
    FormControlPipe,
    FormGroupPipe,
    MeetingTypePipe,
    AttendeeTypePipe,
    ShouldShowInstitutionalInvestorTypePipe
  ]
})
export class PipesModule { }
